<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>QR Obras</h2>
    <h3>Admin - Geral</h3>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <form [formGroup]="form">
            <div class="form-group row m-b">
              <div class="col-sm-5">
                <label class="col-sm-12 pb-1">QR CODE modo</label>
                <ng-select id="qrcode_mode" class="ng-select-alternative" [items]="entity?.mode_list" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="qrcode_mode">
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('qrcode_mode')" [erros]="fieldErros('qrcode_mode')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-5">
                <label class="col-sm-12 pb-1">QR CODE url</label>
                <input type="qrcode_url" id="qrcode_url" class="form-control" formControlName="qrcode_url" />
                <app-field-message [field]="fieldMessageRequired('qrcode_url')" [erros]="fieldErros('qrcode_url')"></app-field-message>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button class="btn btn-primary" type="button" (click)="salvar()">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>